import { render } from "./cleanRecordForTest.vue?vue&type=template&id=4cbc6699&scoped=true"
import script from "./cleanRecordForTest.vue?vue&type=script&lang=js"
export * from "./cleanRecordForTest.vue?vue&type=script&lang=js"

import "./cleanRecordForTest.vue?vue&type=style&index=0&id=4cbc6699&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbc6699"]])

export default __exports__